import { mapActions, mapState } from 'vuex';

import funcoes from "../../../util/funcoes.js";
import { BANCOS, FORMA_PAGAMENTO, STATUS_CONTRATO_ALUGUEL, TIPO_ALUGUEL, FORMA_PAGAMENTO_LANCAMENTO_CAIXA } from "../../../util/constantes";

import AppLiberarRepasseDialog from '../../clientes/dialogs/LiberarRepasseDialog.vue';
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faExchangeAlt, faBalanceScale, faCalendarCheck, faCalendarTimes, faUniversity } from '@fortawesome/free-solid-svg-icons';

library.add(faExchangeAlt, faBalanceScale, faCalendarCheck, faCalendarTimes, faUniversity)

export default {
  components: {
    AppLiberarRepasseDialog,
    FontAwesomeIcon
  },
  data() {
    return {
      tabSelecionada: 'baixasRepasse',

      baixa: {
        aluguel: { enviadoParaJuridico: undefined, emProcessoJudicial: undefined },
        status: 'EM_ABERTO',
        formaPagamento: 'RECEBIMENTO_IMOBILIARIA',
        dataInicial: funcoes.primeiroDiaMes(),
        dataFinal: funcoes.ultimoDiaMes(),
        tipoAluguel: undefined,
        pagoLocatario: false,
        cliente: {
          id: 0
        }
      },
      repasse: {
        recibos: undefined,
        dataRepasse: funcoes.hoje(),
        imprimirDuasVias: true,
      },
      currentPage: 1,
      maxItens: 100,

      hoverLiberar: false,
      detalheLancamento: {},
      detalhesLancamento: [],

      quantidadeViasPopoverIsVisible: false,
      isVisibleFiltrosAdicionais: false,

      tipoDataPagamento: 'DATA_PAGAMENTO',
      banco: undefined,
      contrato: undefined,
      numero: undefined,
      loadingClientes: false,

      reciboSelecionado: undefined,
      visibilidadeLiberarRepasseDialog: false,

      statusRecibos: [
        { label: 'Em Aberto', data: 'EM_ABERTO' },
        { label: 'Pago', data: 'PAGO' }
      ],

      validacao: {
        dataRepasse: [{ required: true, len: 10 }],
      }
    }
  },
  computed: {
    ...mapState('baixasStore', {
      repasses(state) { return state.repasses },
      clientesDisponiveis(state){ return state.listaClientes.lista}
    }),
    exibirBanco() {
      return this.baixa.formaPagamento === 'DEPOSITO_EM_CONTA'
    },
    quantidadeSelecionados(){
      return this.repassesFiltrados.filter((item) => { return item.selecionado === true }).length;
    },
    exibirTipoData() {
      return this.baixa.status === 'PAGO'
    },
    exibirLiberacao() {
      return this.baixa.status === 'EM_ABERTO' && this.baixa.formaPagamento === 'DEPOSITO_EM_CONTA' || this.baixa.formaPagamento === 'RECEBIMENTO_IMOBILIARIA'
    },
    bancos() {
      return BANCOS
    },
    formasPagamento() {
      return FORMA_PAGAMENTO
    },
    tiposAluguel() {
      return TIPO_ALUGUEL
    },
    repassesFiltrados() {
      return this.repasses
        .filter(this.filtrarPorEnviadoAoJuridico)
        .filter(this.filtrarPorEmProcessoJudicial)
        .filter(item => { return this.baixa.tipoAluguel ? (item.aluguel.tipoAluguel === this.baixa.tipoAluguel) : true })
        .filter(item => { return this.contrato ? (item.aluguel.idNaImobiliaria.includes(this.contrato)) : true})
        .filter(item => { return this.numero ? String(item.numero).includes(String(this.numero)) : true})
        .filter(item => { return this.baixa.pagoLocatario ? (item.dataPagamentoLocatario) : true })
        .filter(item => { return this.baixa.pagoLocatario && this.baixa.tipoAluguel === 'NAO_GARANTIDO' ? (item.dataPagamentoLocatario) : true })
        .filter(item => { return item.formaPagamento === this.baixa.formaPagamento })
        .filter(this.filtroPorBanco)
    },
    repassesFiltradosPorPagina(){
      return this.repassesFiltrados.slice((this.currentPage - 1)* this.maxItens, this.currentPage * this.maxItens);
    },
    quantidadeRepassesFiltrados() {
      return this.repassesFiltrados.length;
    },
    exibirlabelSelecao(){
      return this.repassesFiltrados.filter((item) => { return item.selecionado === true }).length > 0; 
    }, 
    labelQuantidadeRepasses() {
      switch (this.repassesFiltrados.length) {
          case 1:
              return `Exibindo 1 repasse`
          case 0:
              return '';
          default:
              return `Exibindo ${(this.currentPage - 1)*this.maxItens + 1} a ${this.repassesFiltradosPorPagina.length + ((this.currentPage - 1) * this.maxItens)} de ${this.quantidadeRepassesFiltrados} repasses`
      }
    },
    labelQuantidadeSelecao(){
      switch (this.quantidadeSelecionados){ 
        case 1: return "1 Repasse selecionado"
        default: return `${this.quantidadeSelecionados} Repasses selecionados`
      }  
    },
    textoBotaoToggleMaisFiltros() {
      return this.isVisibleFiltrosAdicionais
        ? 'Menos Filtros'
        : 'Mais Filtros';
    },
  },
  methods: {
    ...mapActions([
      'showLoading',
      'hideLoading'
    ]),

    ...mapActions('baixasStore', [
      'listarRepasses',
      'listarClientes',
      'selecionarTodos',
      'deselecionarTodos',
      'gerarTodosDemonstrativos',
      'liberarRepasseEmLote',
    ]),

    ...mapActions('alugueisClientesStore', ['liberarRepasseEmLoteImobiliaria']),

    ...mapState("loginStore", {
      usuarioLogado(state) { return state.usuarioLogado },
      permissoes(state) { return state.usuarioLogado.permissoes.filter((permissao) => { return permissao.modulo == "CLIENTES_ALUGUEL" })[0] }
    }),

    filtrarPorEnviadoAoJuridico(recibo) {
      const filtro = this.baixa.aluguel.enviadoParaJuridico;

      const isFiltroDesativado = filtro === undefined;
      if (isFiltroDesativado) return true;

      return recibo.aluguel.enviadoParaJuridico === filtro;
    },

    filtrarPorEmProcessoJudicial(recibo) {
      const filtro = this.baixa.aluguel.emProcessoJudicial;

      const isFiltroDesativado = filtro === undefined;
      if (isFiltroDesativado) return true;

      return recibo.aluguel.emProcessoJudicial === filtro;
    },

    filtroPorBanco(recibo) {
      if (this.baixa.formaPagamento === 'DEPOSITO_EM_CONTA') {
        if (this.banco) {
          if (recibo.cliente.contasBancarias[0]) {
            return recibo.cliente.contasBancarias[0].banco.includes(this.banco);
          }
        }
      }
      return true;
    },

    listarRepassesHandler() {
      this.showLoading();
      this.currentPage = 1;
      this.baixa.cliente = {
        id: this.baixa.cliente.id
      }
      const payload = Object.assign({}, this.baixa);

      if (this.baixa.status === 'EM_ABERTO') {
        payload.dataVencimentoInicio = this.baixa.dataInicial;
        payload.dataVencimentoFim = this.baixa.dataFinal;
      } else {
        switch (this.tipoDataPagamento) {
          case 'DATA_PAGAMENTO':
            payload.dataPagamentoInicio = this.baixa.dataInicial;
            payload.dataPagamentoFim = this.baixa.dataFinal;
            break;
          case 'DATA_BAIXA':
            payload.dataBaixaInicio = this.baixa.dataInicial;
            payload.dataBaixaFim = this.baixa.dataFinal;
            break;
        }
      }

      delete payload.dataInicial;
      delete payload.dataFinal;
      delete payload.tipoAluguel;
      delete payload.pagoLocatario;

      this.listarRepasses(payload)
        .then(() => {
          this.hideLoading();
        })
        .catch(() => {
          this.hideLoading();
          this.$message.error("Não foi possível conectar-se ao servidor");
        });
    },

    // DIALOGS
    handleExibirLiberarRepasseDialog(recibo) {
      const reciboIsPago = recibo.status === 'PAGO';
      if(reciboIsPago) return;
      
      this.exibirLiberarRepasseDialog(recibo);
    },
    exibirLiberarRepasseDialog(recibo) {
      this.reciboSelecionado = recibo
      this.visibilidadeLiberarRepasseDialog = true
    },
    fecharLiberarRepasseDialog() {
      this.visibilidadeLiberarRepasseDialog = false;
    },
    concluirPagamentoRepasse() {
      this.visibilidadeLiberarRepasseDialog = false;
      this.listarRepassesHandler();
    },

    recebidoNaImobiliaria(recibo) {
      return (recibo.formaPagamento == "RECEBIMENTO_IMOBILIARIA")
    },

    permissaoLancarRepasseCaixa(){
      return this.usuarioLogado.imobiliaria.parametros.lancarRepasseCaixa;
    },
    formasPagamentoCaixa() {
      return FORMA_PAGAMENTO_LANCAMENTO_CAIXA;
    },
    //CLIENTE
    filtrarClientesSelect(queryString) {
      let payload = {};
      let reg = /^\d+$/;

      reg.test(queryString) ? payload.idNaImobiliaria = queryString : payload.nome = queryString;
      this.loadingClientes = true
      this.listarClientes(payload)
        .then(() => {
          this.loadingClientes = false;
        }).catch(() => {
          this.loadingClientes = false;
        });
    },
    formatarSelectCliente(cliente){
      return funcoes.formatarSelectCliente(cliente);
    },

    resetCliente(){
      this.baixa.cliente = {
        id: 0
      }
    },
    // UTIL
    gerarDemonstrativos1via() {
      this.repasse.imprimirDuasVias = false;
      this.quantidadeViasPopoverIsVisible = false;
      this.gerarTodosDemonstrativosHandler();
    },
    gerarDemonstrativos2vias() {
      this.repasse.imprimirDuasVias = true;
      this.quantidadeViasPopoverIsVisible = false;
      this.gerarTodosDemonstrativosHandler();
    },
    gerarTodosDemonstrativosHandler() {
      this.repasse.recibos = this.repassesFiltrados.filter(item => item.selecionado);
      this.repasse.recibos = this.repasse.recibos.map(item => item.id);

      if (this.repasse.recibos.length === 0) {
        this.$message.warning("Selecione pelo menos um aluguel");
        return;
      }

      this.showLoading();

      this.gerarTodosDemonstrativos(this.repasse)
        .then(resultado => {
          switch (resultado.status) {
            case "SUCESSO":
              window.open(resultado.item, "_blank");
              break;
            case "ERRO":
              this.$message.error(resultado.mensagem);
          }
        })
        .catch(() => {
          this.$message.error("Não foi possível conectar-se ao servidor");
        })
        .finally(() => {
          this.hideLoading();
        });
    },

    handleSelecionarTodosPorPagina(){

    },

    liberarRepasseEmLoteHandler(){
      if(this.baixa.formaPagamento === 'DEPOSITO_EM_CONTA'){
        this.liberarRepasseEmLoteDeposito()
      }else if(this.baixa.formaPagamento === 'RECEBIMENTO_IMOBILIARIA'){
        this.liberarRepasseEmLoteNaImobiliaria()
      }
    },
    liberarRepasseEmLoteNaImobiliaria(){ 
      this.$refs['form2'].validate((valid) => {
        if (valid) {
          this.$confirm("Liberar repasses com a data de " + this.repasse.dataRepasse + ". Repasses com Baixa Bloqueada não serão liberados!", "Atenção", {
            confirmButtonText: "Confirmar",
            cancelButtonText: "Cancelar",
            type: "warning"
          }).then(() => {
            this.showLoading()
            this.repasse.recibos = this.repassesFiltrados.filter((item) => { return item.selecionado === true && this.recebidoNaImobiliaria(item) &&  this.permissaoLancarRepasseCaixa})
            this.repasse.recibos = this.repasse.recibos.map((item) => { return item.id })
            this.liberarRepasseEmLoteImobiliaria(this.repasse).then(resultado => {
              this.hideLoading()
              switch (resultado.status) {
                case "SUCESSO":
                  this.$message.success(resultado.mensagem);
                  this.listarRepassesHandler()
                  break;
                case "FALHA":
                  this.$message.warning(resultado.mensagem);
                  break;
                default:
                  this.$message.error(resultado.mensagem);
                  break;
              }
            })
              .catch(() => {
                this.hideLoading()
                this.$message.error("Não foi possível conectar-se ao servidor");
              });
          });
        } else {
          this.$message.warning("Preencha a data de repasse!");
        }
      })
    },

    liberarRepasseEmLoteDeposito() {
      this.$refs['form2'].validate((valid) => {
        if (valid) {
          this.$confirm("Liberar repasses com a data de " + this.repasse.dataRepasse + ". Repasses com Baixa Bloqueada não serão liberados!", "Atenção", {
            confirmButtonText: "Confirmar",
            cancelButtonText: "Cancelar",
            type: "warning"
          }).then(() => {
            this.showLoading()
            this.repasse.recibos = this.repassesFiltrados.filter((item) => { return item.selecionado === true && item.formaPagamento === 'DEPOSITO_EM_CONTA' })
            this.repasse.recibos = this.repasse.recibos.map((item) => { return item.id })
     
            this.liberarRepasseEmLote(this.repasse).then(resultado => {
              this.hideLoading()
              switch (resultado.status) {
                case "SUCESSO":
                  this.$message.success(resultado.mensagem);
                  this.listarRepassesHandler()
                  break;
                case "FALHA":
                  this.$message.warning(resultado.mensagem);
                  break;
                default:
                  this.$message.error(resultado.mensagem);
                  break;
              }
            })
              .catch(() => {
                this.hideLoading()
                this.$message.error("Não foi possível conectar-se ao servidor");
              });
          });
        } else {
          this.$message.warning("Preencha a data de repasse!");
        }
      })
    },
    getLabelFormaPagamento(item) {
      return funcoes.getLabel(this.formasPagamento, item.formaPagamento)
    },
    getLabelBanco(item) {
      if(!item.cliente.contasBancarias[0]) return '';
      
      return funcoes.getLabel(this.bancos, item.cliente.contasBancarias[0].banco)
    },
    getLabelStatus(item) {
      return funcoes.getLabel(this.statusRecibos, item.status)
    },
    getLabelStatusAluguel(item) {
      return funcoes.getLabel(STATUS_CONTRATO_ALUGUEL, item.aluguel.status)
    },
    getLabelTipoAluguel(item) {
      return funcoes.getLabel(TIPO_ALUGUEL, item.aluguel.tipoAluguel)
    },
    formatarPeriodo(item) {
      return item.inicioPeriodo + ' - ' + item.fimPeriodo
    },
    formatarValor(item) {
      return funcoes.formatarValor(item.valor)
    },
    formatarValorPago(item) {
      return funcoes.formatarValor(item.valorPagamento)
    },
    formatarIconStatus(item) {
      switch (item) {
        case 'EM_ABERTO':
          return '#4B6EF6'; 
        case 'PAGO':
          return '#2DB748';
      }
    },
    handleClickToggleMaisFiltros(){
      this.isVisibleFiltrosAdicionais = !this.isVisibleFiltrosAdicionais;
    }
    
  }
}